import { render, staticRenderFns } from "./SecurityPolicy.vue?vue&type=template&id=33b8abf8&scoped=true"
import script from "./SecurityPolicy.vue?vue&type=script&lang=ts"
export * from "./SecurityPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b8abf8",
  null
  
)

export default component.exports